require("dotenv").config();

export const port = process.env.PORT;
export const host = `localhost:${port}`;
export const url = process.env.WEBSITE_URL;
export const socketUrl = process.env.SOCKET_URL;
export const socketPort = process.env.SOCKET_PORT;
export const apiUrl = process.env.API_URL;
export const environment = true;

export const analytics = {
    // https://analytics.google.com/
    google: { trackingId: "UA-XXXXX-X" },
};

export const databaseUrl = process.env.DATABASE_URL;
export const coinbase = process.env.COINBASE_URL;
export const coinbaseCurrencyUrl = process.env.COINBASE_CURRENCY_URL;
export const placeDetailURL = process.env.PLACE_DETAILS_URL;
export const autoCompleteURL = process.env.PLACES_AUTOCOMPLETE_URL;

// export const locales = ["en-US", "es", "it-IT", "fr-FR", "pt-PT", "ar", "he"]; // default locale is the first one

export const locales = ["fr-FR", "en-US", "ar"]; // default locale is the first one

export const fileuploadDir = process.env.FILEUPLOAD_DIR; // Listing Photos Upload Directory
export const logouploadDir = process.env.LOGOUPLOAD_DIR; // Logo upload directory
export const ogImageuploadDir = process.env.OGIMAGEUPLOAD_DIR; // OG Image Upload directory
export const banneruploadDir = process.env.BANNER_UPLOAD_DIR; // Home page Banner upload directory
export const profilePhotouploadDir = process.env.PROFILE_PHOTO_UPLOAD_DIR; // User Profile Photos Upload Directory
export const documentuploadDir = process.env.DOCUMENT_UPLOAD_DIR; // Document Upload
export const locationuploadDir = process.env.POPULAR_UPLOAD_DIR; // Location upload directory
export const homebanneruploadDir = process.env.HOME_BANNER_UPLOAD_DIR; // Static block image upload directory
export const amenitiesUploadDir = process.env.AMENITIES_UPLOAD_DIR; // Amenities upload directory
export const faviconUploadDir = process.env.FAVICON_UPLOAD_DIR; // Favicon images update directory
export const whyHostUploadDir = process.env.WHYHOST_UPLOAD_DIR; // whyHostUploadDir

export const cronTimezone = process.env.CRON_TIMEZONE;
export const searchLimit = 24;
export const searchPagination = 300;
export const restrictStaticPageDisable = [4, 5, 6, 7];

export const locations = [
    //example
//{id: 0, name: 'Ain Drahem', value: 'Ain Drahem, Jendouba'},
{id: 0, name: 'Ain Drahem'},
{id: 1, name: 'Béja'},
{id: 2, name: 'Marsa - Sidi Bousaid'},
{id: 3, name: 'Bizerte'},
{id: 4, name: 'Djerba'},
{id: 5, name: 'Haouaria'},
{id: 6, name: 'Hammamet'},
{id: 7, name: 'Kerkannah'},
{id: 8, name: 'Kef'},
{id: 9, name: 'Kelibia'},
{id: 10, name: 'Korba - Tazarka'},
{id: 11, name: 'Mahdia'},
{id: 12, name: 'Mornag - Soliman'},
{id: 13, name: 'Nabeul'},
{id: 14, name: 'Retiba'},
{id: 15, name: 'Sousse - Monastir'},
{id: 16, name: 'Tabarka'},
{id: 17, name: 'Tozeur'},
{id: 18, name: 'Tunis'},
{id: 19, name: 'Zaghouan'},
{id: 20, name: 'Tataouine'},
// {id: 19, name: 'Jendouba'},

]

export const payment = {
    paypal: {
        returnURL: `${url}${process.env.PAYPAL_RETURN_URL}`,
        cancelURL: `${url}${process.env.PAYPAL_CANCEL_URL}`,
        redirectURL: {
            success: `${url}${process.env.PAYPAL_SUCCESS_REDIRECT_URL}`,
            cancel: `${url}${process.env.PAYPAL_CANCEL_URL}`,
        },
        versions: {
            versionOne: "/v1",
            versionTwo: "/v2",
        },
        token_url: "/oauth2/token",
        payment_url: "/checkout/orders",
        capture_url: "/capture",
        payout_url: "/payments/payouts",
        refund: "/refund",
        refund_capture: "/payments/captures/",
    },
    stripe: {
        failure_url: `${url}${process.env.STRIPE_FAILURE_URL}?account=`,
        success_url: `${url}${process.env.STRIPE_SUCCESS_URL}?account=`,
    },
    clickToPay: {
        baseUrl: process.env.CLICKTOPAY_BASE_URL || "https://test.clictopay.com",
        userName: process.env.CLICKTOPAY_USERNAME,
        password: process.env.CLICKTOPAY_PASSWORD,
        returnUrl: process.env.CLICKTOPAY_RETURN_URL || `${url}/click-to-pay/return`,
        failUrl: process.env.CLICKTOPAY_FAIL_URL || `${url}/click-to-pay/fail`,
        language: process.env.CLICKTOPAY_LANGUAGE || "fr",
        ignoreTlsErrors: process.env.CLICKTOPAY_IGNORE_TLS_ERRORS === "true",
    },
};

export const auth = {
    jwt: { secret: process.env.JWT_SECRET },
    redirectURL: {
        login: "/dashboard",
        verification: "/user/verification",
        userbanned: "/userbanned",
        returnURLDeletedUser: "/userbanned",
    },
    google: {
        returnURL: `${url}/login/google/return`,
    },
};
